<script setup>
// test测试组件
const title = "测试";
</script>

<template>
  <div class="">{{ title }}</div>
</template>

<style lang="scss" scoped></style>
